export const STEADILY_URL = "https://hubzu.steadilypartner.com/partner/v3.js";
export const InvestmentCalcPrefix =
  "http://calculationservice-integ.internal.hubzu.com";
export const InvestmentCalcURL =
  "calculation-service/api/v1/datahub/datapoints";

export const checkEmail =
  "Check your inbox at {email} and follow the instructions to reset your password.";
export const userDeletedEmail =
  "The account associated with the given email address is marked for deletion. Please provide a different email address.";
export const emailNotFound =
  "Please enter valid email address.";

export const informationUsed =
  "The information you provide in this form will be used to prepare relevant transaction documents (e.g., purchase and sale agreement, property information disclosure forms, settlement statements, deed, etc.) if your bid is selected by the seller to proceed with the transaction. Because of this, please be sure that the information provided is complete and accurate and that proper legal names are used. If the information provided is not accurate or complete, the seller may choose to disregard your bid and pursue the transaction with other bidders.";

export const acknowledgementStatement =
  "I hereby acknowledge that the information provided in this contact Information form is complete and accurate. I understand that such information will be used to prepare the transaction documents for the purchase of the property if my bid is selected by the seller to proceed with the transaction.";

//PDP
export const foreclosureTxt =
  "You could save thousands on real estate purchase fees. Find off-market property auctions with no buyer's premium.";

export const shortSaleTxt =
  "A short sale occurs when a lender is willing to accept an offer that's less than the total amount owed on the mo.";

export const cwcotTxt =
  "Originally created in 1987, the CWCOT program aims to reduce the number of homes in the U.S. Department of Housi.";

//! ******* Bidwizard Static content*****

export const purchase_Profile_Static_Info =
  "The information you provided in this form will be used to prepare relevant transaction documents(e.g. purchase and sale agreement, property information disclosure forms, settlement statements, deeds, etc.) if your bid is selected by the seller to proceed with the transaction, Because of this, Please be sure that the information provided is complete and accurate and that proper legal names are used.If the information provided is not accurate or complete,the seller may choose to disregard your bid and pursue the transaction with other bidders.";

export const profile_Info_Title =
  " For more information on registration process, please see our FAQs";

export const profile_Info_Reg_que =
  "Do I need to register to bid or make an offer on a property?";

export const profile_Info_Reg_ans =
  "Yes, you need to register and verify your credentials to make an offer/bid on a property.";

export const profile_Info_User_que =
  "After I register, how do I change my user information?";

export const profile_Info_User_ans =
  "To change your profile information, sign in and go to the section of your Hubzu account. Simply update the appropriate fields and click at the bottom of the page.";

export const BidDeposit_Info =
  "The bid deposit is a hold placed on your credit card before you can place a bid on applicable properties on Hubzu. This is used to verify that you are a serious bidder with intent to purchase the property. The bid deposit hold is one of the steps we take to help ensure that the bidding pool is comprised of serious bidders. If you are not the selected bidder, the hold will be removed within 4-7 business days after the auction cycle has ended. If you are the selected bidder, the Bid Deposit will be released once we receive confirmation from the third-party escrow agent that your earnest money deposit (or EMD) was received within the time frame set forth in the purchase and sale agreement. Please allow 4-7 business days for the hold to be removed after the PSA and EMD are received.";

export const BidDeposit_Info_Selected_Bidder =
  "If you are the selected bidder and you fail to deliver your earnest money deposit within the required time frame, the hold will be converted into an actual charge on your credit card in the amount of the bid deposit listed below.";

export const BidDeposit_Info_Required =
  " Please keep in mind, the bid deposit hold is required once for every applicable property in order to place a bid on said property. The bid deposit amount can be found below.";
// !**** tool tip***
export const cardTooltip =
  "Auto Bid saves you time by placing incremental bids for you. You control the limit.";
export const cardTooltip2 =
  "Paid by the buyer at closing, this fee covers the costs of facilitating an auction sale on Hubzu.";
export const cardTooltip3 =
  "Your backup bid and bid deposit hold will be in place from the end of the auction through the duration period selected. The seller may consider backup bids if they are unable to proceed with the selected bidder.";
export const cardTooltip4 =
  " Select No only if you have a written mortgage commitment from your lender. If you select No and are unable to secure financing by the closing date, your Earnest Money deposit may not be refunded";

export const ClosingOptionTextSeller =
  "Buyer uses Premium Title Services, the seller's preferred title partner and closing agent. This lets the buyer bypass the title insurance fees, related search costs and reduced escrow/closing fees, since the seller will cover the charges. The standard charge for title insurance services in {state} is {amount}. Please note that buyers making all-cash purchases are automatically opted in to save through this method.";
export const ClosingOptionTextBuyer =
  "Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses.";
export const question_Tour_One = "Have you toured the property?";
export const question_Planning_Occupuy =
  " Is (are) the buyer(s) planning to occupy the property themselves?";
export const question_planning_Licenece =
  " Is (are) the buyer(s) currently a licensed real estate agentor broker in any state?";

export const tourSlides = [
  {
    title: "Find Your Next Investment",
    description:
      "Browse and bid on over 3,000 exclusive properties, including fixer-uppers, foreclosures and luxury houses at prices you can't turn down.",
  },
  {
    title: "Boost Your Portfolio",
    description:
      "With Hubzu, you can be confident in your investments. Find rental estimates, market analysis and property history-get started with Free registration!",
  },
  {
    title: "Bidding Made Easy",
    description:
      "Bid by text, set a maximum price, and make a back-up bid, so you can be in the running even after the auction is over, all on easy-to-use platform or mobile app.",
  },
];

export const srpTourSlides = [
  {
    title: "Boost Your Portfolio",
    description:
      "Browse and bid with confidence on our leading, tech-savvy home auction marketing platform. Get started with FREE registration!",
  },
  {
    title: "Browse with Confidence",
    description:
      "Find rental estimates, market analysis and property history while you browse. With us, you can be confident in your investments.",
  },
  {
    title: "Bidding Made Easy",
    description:
      "Bid by text, set a maximum price, and make a back-up bid so you can be in the running even after the auction is over, all on our easy-to-use platform and mobile app.",
  },
];

export const pdpTourSlides = [
  {
    title: "Browse with Confidence",
    description:
      "Find rental estimates, market analysis and property history while you browse. With us, you can be confident in your investments.",
  },
  {
    title: "Bidding Made Easy",
    description:
      "Bid by text, set a maximum price, and make a back-up bid so you can be in the running even after the auction is over, all on our easy-to-use platform or mobile app.",
  },
  {
    title: "Find Your Next Investment",
    description:
      "Browse and bid on over 3,000 exclusive properties, including fixer-uppers, foreclosures and luxury houses at prices you can't resist.",
  },
];

export const sell = {
  residential: {
    hero: {
      title: "Sell Your Property Using Hubzu's Nationwide Marketplace",
      description:
        "Take advantage of the power of auction marketing to sell your property now!",
      contactDesc: "Call (877) 267-3854 or click below to register.",
      subDescription: "",
    },
    faq: {
      title: "Frequently Asked Questions",
      desc: "* The $995 program participation fee is per property and will be refunded if your property is sold to a bidder through the Hubzu platform. Hubzu will refund this fee at time of closing and can also be applied to your closing cost if you prefer. This fee is non-refundable if you choose to withdraw your property from Hubzu or if the property is sold through any other method or platform.",
    },
    milestones: [
      {
        value: "2.5M+",
        text: "Registered Users",
      },
      {
        value: "$978M+",
        text: "Commission Paid to Listing & Buyer Agents Combined",
      },
      {
        value: "269K+",
        text: "Properties Sold",
      },
    ],
    howItWorks: {
      title: "How it Works",
      desc: "Are you ready to increase the visibility of your property and engage with a broad audience of potential buyers? The Hubzu Signature HomesTM program facilitates an auction-based selling option that connects you with buyers nationwide. With a clear, step-by-step process and a refundable participation fee*, we provide a straightforward path to marketing your home. See how our innovative auction marketplace is designed to enhance the exposure of your property and assist you in navigating the selling process efficiently.",
      subDesc: "Learn How it Works Below",
      workSteps: [
        {
          id: "01",
          title: "Registration is Free",
          description:
            "Begin by filling out the registration form on this page. After submission, an account manager will contact you to discuss the Hubzu Signature Homes program, detailing how the $995 participation fee is not only an investment in marketing services but also fully refundable upon the successful sale of your property to a Hubzu bidder.",
          image: "https://image-prod.hubzu.com/Footer/consumer1.png",
          reverse: false,
          haveBgColor: true,
        },
        {
          id: "02",
          title: "Become a Verified Member",
          description:
            "Your account manager will verify your details and explain the program terms. Sign and return the agreement, and pay the participation fee to get your account approved. Remember, this fee is refunded once your property sells to a Hubzu bidder, making this a low-cost investment in selling your property faster and at a potentially higher price.",
          image: "https://image-prod.hubzu.com/Footer/consumer2.jfif",
          reverse: true,
          haveBgColor: false,
        },
        {
          id: "03",
          title: "Auction Time",
          description:
            "Upload your properties on Hubzu and provide the necessary property descriptions, photos, etc. Your account manager will review the property information and marketing details to ensure everything is set for success. Once approved, your property will be scheduled for its initial auction cycle on the Hubzu platform, ensuring optimal exposure and attractiveness to bidders.",
          image: "https://image-prod.hubzu.com/Footer/consumer3.jfif",
          reverse: false,
          haveBgColor: false,
        },
        {
          id: "04",
          title: "Watch the Bids Come In",
          description:
            "As bids start rolling in, you can select the best offer to move forward with the sale. If the bids from the initial cycle are not satisfactory, your property will be entered into subsequent auction cycles. We recommend allowing at least four cycles to maximize exposure and buyer competition.",
          image: "https://image-prod.hubzu.com/Footer/consumer4.jfif",
          reverse: true,
          haveBgColor: false,
        },
      ],
    },
  },
  commercial: {
    hero: {
      title:
        "Sell Your Commercial Property Using Hubzu's Nationwide Marketplace",
      description:
        "Maximize Exposure. Attract Serious Buyers. Close with Confidence.",
      contactDesc: "Call (877) 267-3854 or click below to contact us.",
      subDescription: "",
    },
    faq: {
      title: "Frequently Asked Questions",
      desc: "* The $995 program participation fee is per property and will be refunded if your property is sold to a bidder through the Hubzu platform. Hubzu will refund this fee at time of closing and can also be applied to your closing cost if you prefer. This fee is non-refundable if you choose to withdraw your property from Hubzu or if the property is sold through any other method or platform.",
    },
    milestones: [
      {
        value: "2.5M+",
        text: "Registered Users",
      },
      {
        value: "$978M+",
        text: "Commission Paid to Listing & Buyer Agents Combined",
      },
      {
        value: "269K+",
        text: "Properties Sold",
      },
    ],
    howItWorks: {
      title: "Why Choose Hubzu for Your Commercial Real Estate Sale?",
      desc: "Hubzu is a trusted leader in real estate auctions, now bringing its expertise to the commercial sector. Whether you're selling a multi-unit office building, retail center, industrial warehouse, or undeveloped land, Hubzu can help.",
      subDesc: "Learn more",
      workSteps: [
        {
          id: "01",
          title: "",
          description: "",
          features: [
            {
              title: "Access to 2.6+ million registered users",
              description: "Giving your property nationwide visibility.",
            },
            {
              title: "Targeted marketing strategies",
              description: "Reaching serious commercial investors.",
            },
            {
              title: "Competitive bidding environment",
              description: "Designed to drive optimal outcomes.",
            },
            {
              title: "Streamlined auction process",
              description: "Reducing complexities and saving time.",
            },
          ],

          image: "https://image-prod.hubzu.com/Footer/consumer3.jfif",
          reverse: false,
          haveBgColor: false,
        },
        {
          id: "02",
          title: "Effortless Selling with Expert Support",
          description:
            "Hubzu works with industry professionals to provide comprehensive due diligence and underwriting services, giving Buyers the confidence to act fast. With transperent bidding and detailed property insights, Hubzu can help you navigate the process smoothly from listing to closing.",
          features: [],
          image: "https://image-prod.hubzu.com/Footer/consumer4.jfif",
          reverse: true,
          haveBgColor: false,
        },
      ],
    },
  },
  broker: {
    hero: {
      title: "Brokers, want to earn an extra 2% commission?",
      description:
        "Now you can with the Hubzu broker program for listing agents and brokers!*",
      contactDesc: "Call (877) 267-3854 or click below to learn more.",
      subDescription:
        "Agents, is your broker already a member? Register for the program by clicking here.",
    },
    faq: {
      title: "Frequently Asked Questions",
      desc: "* The $995 program participation fee is per property and will be refunded if your property is sold to a bidder through the Hubzu platform. Hubzu will refund this fee at time of closing and can also be applied to your closing cost if you prefer. This fee is non-refundable if you choose to withdraw your property from Hubzu or if the property is sold through any other method or platform.",
    },
    milestones: [
      {
        value: "2.5M+",
        text: "Registered Users",
      },
      {
        value: "$978M+",
        text: "Commission Paid to Listing & Buyer Agents Combined",
      },
      {
        value: "269K+",
        text: "Properties Sold",
      },
    ],
    howItWorks: {
      title: "How it Works",
      desc: "Are you ready to increase the visibility of your property and engage with a broad audience of potential buyers? The Hubzu Signature HomesTM program facilitates an auction-based selling option that connects you with buyers nationwide. With a clear, step-by-step process and a refundable participation fee*, we provide a straightforward path to marketing your home. See how our innovative auction marketplace is designed to enhance the exposure of your property and assist you in navigating the selling process efficiently.",
      subDesc: "Learn How it Works Below",
      workSteps: [
        {
          id: "01",
          title: "Registration is Free",
          description:
            "Begin by filling out the registration form on this page. After submission, an account manager will contact you to discuss the Hubzu Signature Homes program, detailing how the $995 participation fee is not only an investment in marketing services but also fully refundable upon the successful sale of your property to a Hubzu bidder.",
          image: "https://image-prod.hubzu.com/Footer/consumer1.png",
          reverse: false,
          haveBgColor: true,
        },
        {
          id: "02",
          title: "Become a Verified Member",
          description:
            "Your account manager will verify your details and explain the program terms. Sign and return the agreement, and pay the participation fee to get your account approved. Remember, this fee is refunded once your property sells to a Hubzu bidder, making this a low-cost investment in selling your property faster and at a potentially higher price.",
          image: "https://image-prod.hubzu.com/Footer/consumer2.jfif",
          reverse: true,
          haveBgColor: false,
        },
        {
          id: "03",
          title: "Auction Time",
          description:
            "Upload your properties on Hubzu and provide the necessary property descriptions, photos, etc. Your account manager will review the property information and marketing details to ensure everything is set for success. Once approved, your property will be scheduled for its initial auction cycle on the Hubzu platform, ensuring optimal exposure and attractiveness to bidders.",
          image: "https://image-prod.hubzu.com/Footer/consumer3.jfif",
          reverse: false,
          haveBgColor: false,
        },
        {
          id: "04",
          title: "Watch the Bids Come In",
          description:
            "As bids start rolling in, you can select the best offer to move forward with the sale. If the bids from the initial cycle are not satisfactory, your property will be entered into subsequent auction cycles. We recommend allowing at least four cycles to maximize exposure and buyer competition.",
          image: "https://image-prod.hubzu.com/Footer/consumer4.jfif",
          reverse: true,
          haveBgColor: false,
        },
      ],
    },
  },
};

export const AccessCode = {
  accesscode: "Access Code",
  firstnamerequired: "Enter first name",
  validfirstname: "Enter valid first name",
  lastnamerequired: "Enter last name",
  validlastname: "Enter valid last name",
  emailrequired: "Enter email",
  validemail: "Enter valid email",
  licensenumberrequired: "Enter license number",
  validlicensenumber: "Enter valid license number",
  licensestate: "Select license state",
  expiredaterequired: "Enter expire date",
  validexpiredate: "Enter valid expire date",
  toview:
    "To view the property’s access code, please provide the information below.Please note that if the Auction has Ended or is Under Review, only the selected bidder will be provided an access code to tour the property.",
  agree: "If you are a registered agent, simply ",
  signin: "Sign In ",
  avoidstep: "first to avoid this step",
  submitform: "By submitting this form, you accept the ",
  termsandcond: "Terms and Conditions ",
  and: "and ",
  privacy: "Privacy Policy ",
  ofhubzu: "of Hubzu.",
  viewaccesscode: "View Access Code",
  assistence:
    "For assistance with any access issues, please call our Field Services team while at the property at",
  tollfree: "1-866-592-6514. ",
  available:
    "Available Mondays through Fridays from 9 AM to 8 PM EST, and 10 AM to 7 PM on weekends and holidays.",
  anyqueries:
    "For inquiries on buyer agent’s commission, please contact the listing agent directly.",
  failed: "Failed",
  licenseFailed:
    "Invalid license number. Please enter correct license number to match the given state.",
};

export const AgentLiecenseErrorMsgs = {
  Alabama:
    "Please note: Your license number should be exactly nine digits leading with zeros. Sample License - 000012345",
  Alaska:
    "Please note: Your license number should be two or more digits without leading zeros. Sample License - 12345",
  Arizona:
    "Please note: Your license number should include the prefix(BR|SA) indicating license type followed by exactly nine digits leading with zeros. Sample License - BR000012345",
  Arkansas:
    "Please note: Your license number should include the prefix(AB|EB|IB|PB|SA) indicating license type followed by exactly eight digits leading with zeros. Some license numbers also require the suffix -Dxx. Sample License - AB00001234",
  California:
    "Please note: Your license number should be exactly eight digits with leading zeros. Sample License - 12345678",
  Colorado:
    "Please note: Your license number should include the prefix(EA|EI|ER|FA|IA|II|IR) indicating license type followed by a period(.), followed by exactly nine digits leading with zeros. Sample License - EI.000001234",
  Connecticut:
    "Please note: Your license number should include the prefix(REB|RES) indicating license type followed by a period, followed by exactly seven digits leading with zeros. Sample License - RES.0000123",
  Delaware:
    "Please note: Your license number should include the prefix(RB|RS|R) indicating license type followed by a dash, followed by exactly seven digits leading with zeros. Sample License - RB-0000123",
  "District of Columbia":
    "Please note: Your license number should include the prefix(AB|BO|IB|PB|PM|RM|SP) indicating license type followed by one or more digits. Sample License - AB1234",
  Florida:
    "Please note: Your license number should be two or more digits without leading zeros. Sample License - 12345",
  Georgia:
    "Please note: Your license number should be two or more digits without leading zeros. Sample License - 12345",
  Hawaii:
    "Please note: Your license number should be two or more digits without leading zeros. Sample License - 12345",
  Idaho:
    "Please note: Your license number should be one or more digits without leading zeros. Sample License - 12345",
  Illinois: "No license format information",
  Indiana:
    "Please note: Your license number should include the prefix(RB) indicating license type followed by exactly eight digits leading with zeros. Sample License - RB00001234",
  Iowa: "Please note: Your license number should include the prefix(BFST) indicating license type followed by exactly eight digits leading with zeros. Sample License - BSFT001234",
  Kansas:
    "Please note: Your license number should be exactly eight digits with leading zeros. Sample License - 00000123",
  Kentucky:
    "Please note: Your license number should be one or more digits without leading zeros. Sample License - 1234",
  Louisiana:
    "Please note: Your license number should be one or more digits without leading zeros. Sample License - 1234",
  Maine:
    "Please note: Your license number should be six or more digits without leading zeros. Sample License - 1234567",
  Maryland:
    "Please note: Your license number should be one or more digits without leading zeros. Sample License - 123",
  Massachusetts:
    "Please note: Your license number should be one or more digits without leading zeros followed by a suffix((-RE-)AB|B|C|LC|LP|PC|PG|PL|RB|RS|S|SC) indicating license type. Sample License - 1234-RE-AB",
  Michigan:
    "Please note: Your license number should be exactly ten digits total beginning with 650. Sample License - 6501234567",
  Minnesota: "No license format information",
  Mississippi:
    "Please note: Your license number should include the prefix(S-) indicating license type (salespersons only) followed by three or more digits without leading zeros. Sample License - S-12345",
  Missouri:
    "Please note: Your license number should be exactly ten digits without leading zeros. Sample License - 1234567890",
  Montana:
    "Please note: Your license number should include the prefix(RRE\\-(BRO|RBS|RPM)\\-LIC-) indicating license type followed by one or more digits without leading zeros. Sample License - RRE-BRO-LIC-123",
  Nebraska:
    "Please note: Your license number should be seven or more digits with leading zeros for shorter numbers. Sample License - 00000012",
  Nevada:
    "Please note: Your license number should be exactly seven digits with leading zeros. Sample License - 0000001",
  "New Hampshire":
    "Please note: Your license number should be exactly six digits with leading zeros. Sample License - 000012",
  "New Jersey":
    "Please note: Your license number should be exactly seven digits with leading zeros. Sample License - 0000123",
  "New Mexico": "No license format information",
  "New York": "No license format information",
  "North Carolina":
    "Please note: Your license number should be two or more digits without leading zeros. Sample License - 1234",
  "North Dakota":
    "Please note: Your license number should be two or more digits without leading zeros. Sample License - 1234",
  Ohio: "Please note: Your license number should be the prefix(BRK|SAL) indicating license type followed by a period, followed by exactly ten digits with leading zeros. Sample License - BRK.0000012345",
  Oklahoma:
    "Please note: Your license number should be exactly six digits with leading zeros. Sample License - 000012",
  Oregon:
    "Please note: Your license number should be exactly nine digits without leading zeros. Sample License - 000001234",
  Pennsylvania: "No license format information",
  "Rhode Island":
    "Please note: Your license number should be a prefix(REB/RBS) indicating license type followed by a period, followed by exactly seven digits with leading zeros. Sample License - REB.0000123",
  "South Carolina":
    "Please note: Your license number should be four or more digits without leading zeros. Sample License - 1234",
  "South Dakota":
    "Please note: Your license number should be two or more digits without leading zeros. Sample License - 1234",
  Tennessee:
    "Please note: Your license number should be three or more digits without leading zeros. Sample License - 123",
  Texas:
    "Please note: Your license number should be four or more digits without leading zeros. Sample License - 1234",
  Utah: "Please note: Your license number should begin with six or more digits without leading zeros followed by a suffix(AB00|BB00|CEI0|DB00|MCEI|PB00|PI00|SA00) indicating license type. Sample License - 123456-AB00",
  Vermont:
    "Please note: Your license number should include a prefix(081/082) indicating license type followed by a period, followed by exactly seven digits leading with zeros. Sample License - 081.0000001",
  Virginia: "No license format information",
  Washington: "No license format information",
  "West Virginia":
    "Please note: Your license type should include the letters WV followed by exactly seven digits leading with zeros. Sample License - WV0000123",
  Wisconsin: "No license format information",
  Wyoming:
    "Please note: Your license type should include the prefix(RE-) indicating license type (optional) followed by three or more digits without leading zeros. Sample License - RE-1234",
};

export const ResetPasswordErrorMEssage = {
  ALERT_PASSWORD_MIN_AGE:
    "Sorry, you can only change your password once every 10 days. Please contact Customer Care if you need to reset your password.",
  CURRENT_PASSWORD_AND_NEW_PASSWORD_ARE_SAME:
    "New password is same as old password. Please provide different password.",
  INCORRECT_NEW_PASSWORD: "Password Cannot be blank",
  INVALID_REQUEST_PARAMETER: "Invalid Request Parameter",
  INVALID_TOKEN:
    "Password must be:<ul><li>Between 8 and 20 characters long.</li><li>Include a combination of uppercase and lowercase letters, numbers, and at least one of the following special characters:'!','#','@','%','$',';','^'</li><li>May not be one of your previous 12 passwords or contain your screen name.</li></ul>",
  PASSWORD_VALIDATION_ERROR_EXTERNAL_USER:
    "Password must be between 8 and 20 characters long",
  PASSWORD_VALIDATION_ERROR_INTERNAL_USER:
    "Password must be:<ul><li>Between 8 and 20 characters long.</li><li>Include a combination of uppercase and lowercase letters, numbers, and at least one of the following special characters:'!','#','@','%','$',';','^'</li><li>May not be one of your previous 12 passwords or contain your screen name.</li></ul>",
  SESSION_REQUIRED: "Please Login",
  TECHNICAL_ERROR: "Technical Error",
};
